{
  "name": "nexus-front",
  "version": "1.0.8",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.0.8",
    "@angular/cdk": "^22.0.6",
    "@angular/common": "^22.0.8",
    "@angular/compiler": "^22.0.8",
    "@angular/core": "^22.0.8",
    "@angular/forms": "^22.0.8",
    "@angular/material": "^22.0.6",
    "@angular/platform-browser": "^22.0.8",
    "@angular/platform-browser-dynamic": "^22.0.8",
    "@angular/platform-server": "^22.0.8",
    "@angular/router": "^22.0.8",
    "@angular/ssr": "^22.0.9",
    "@fortawesome/angular-fontawesome": "^4.0.0",
    "@fortawesome/fontawesome-svg-core": "^7.2.0",
    "@fortawesome/free-solid-svg-icons": "^7.2.0",
    "@ngxmc/datetime-picker": "^20.1.0",
    "body-parser": "^1.20.2",
    "bootstrap": "^5.3.3",
    "crypto-browserify": "^3.12.1",
    "eslint-plugin-rxjs": "^5.0.3",
    "express": "^4.18.2",
    "file-saver": "^2.0.5",
    "guid-typescript": "^1.0.9",
    "moment": "^2.30.1",
    "ngx-spinner": "^17.0.0",
    "ngx-toastr": "^20.0.5",
    "pdfmake": "^0.2.15",
    "rxjs": "~7.8.0",
    "tslib": "^2.7.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^18.4.0",
    "@angular-eslint/eslint-plugin": "^18.4.0",
    "@angular-eslint/eslint-plugin-template": "^18.4.0",
    "@angular-eslint/schematics": "^18.4.0",
    "@angular-eslint/template-parser": "^18.4.0",
    "@angular/build": "^22.0.9",
    "@angular/cli": "^22.0.9",
    "@angular/compiler-cli": "^22.0.8",
    "@types/body-parser": "^1.19.3",
    "@types/express": "^4.17.17",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^18.18.0",
    "@typescript-eslint/eslint-plugin": "^7.18.0",
    "@typescript-eslint/parser": "^7.18.0",
    "esbuild-visualizer": "^0.6.0",
    "eslint": "9.32",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~5.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "^6.0.3"
  }
}
